import axios from "axios";
import { apimSubKey, apimUrl,  aviationApiUrl,  domianTableFeature,  domianTableLookupIdCostCenter,  domianTableLookupIdCostingActivity,  domianTableLookupIdEquimentType,  domianTableLookupIdForestrArea,  domianTableLookupIdCostRateType,  domianTableLookupIdTickStatus,  domianTableSubKey, domianTableUrl, financeSubKey, financeUrl, firesSubKey, firesSubKey1, firesUrl, domianTableRelationshipRateTypeCostingActivityId, domianTableLookupIdResourceType, domianTableLookupIdUnitType, domianTableRelationshipForestAreaCostCenterId, domianTableRelationshipEquipmentSpecRatePerUnitId, domianTableRelationshipKeyWorkPerformed } from "../common/constants";
import type { TicketInfo } from "../common/models/TicketInfo";
import type { FireContractInfo, GenListType, InternalOrderDef, TicketsQueryParam } from "../common/types";
import { wdpUtil } from "../common/utils/util";
import { appLog } from "../common/utils/app-log";
import TicketService from "./TicketService";
//import { hasResourceRole } from "../common/utils/tokenUtil";

const backendUrl = `${apimUrl}/time-tickets`;
const lookupUrl = `${domianTableUrl}`




const getConfig = (token: string,subKey?:string) => {
  return {
    // withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
       'Cache-Control': 'no-cache',
      //"X-CSRF": "1",
      'Ocp-Apim-Subscription-Key': subKey ?? apimSubKey,
      Authorization: `Bearer ${token}`,
    },
  };
};




export default class ApiService {
  config: any;
  /**
   *
   * @param token the access_token
   */

  // user timesheets
  
  public static ping = async (token: string ) => {
    const url = `${backendUrl}/`;
    return axios.get(url, { ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };
  public static getFeatureFlags = () => {
    return axios.get(`${backendUrl}/feature-flags`).then((res) => {
      return res.data;
    }).catch(error => appLog.debug(error));
  };
  /*************************************************************************************
   * 
   * @param token 
   * @param qParams 
   * @param controller 
   * @returns 
  *************************************************************************************/

  public static getFilteredTickets = async (token: string, qParams:TicketsQueryParam, controller: AbortController) => {
    
    const url = `${backendUrl}/search`;
    return axios.post(url, qParams,{ ...getConfig(token), signal: controller?.signal }).then((res) => {
    
      appLog.debug(res.data);
      return res.data;
      
    });
  };
  /***********************************************************************************
   * 
   * @param token 
   * @param incId 
   * @returns 
  *************************************************************************************/
  public static getTicketById = async (token: string, ticketNumber:string,withLabels=false,controller?: AbortController) => {
    const url  = `${backendUrl}/${ticketNumber}`;
    return axios.get(url, { ...getConfig(token), signal: controller?.signal }).then((res) => {
      
      // if(withLabels){
      //   // we need the label for some properties .. as we dave just ID in the database ticket record
      //   // fireNUmber,
      //   labels={internalOrder:""};
      // }
      // return {ticketInfo:res.data,labels:labels};
      return res.data;
    });
  };
  /***********************************************************************************
   * Get ticket by digitalId (e.g., "HE-2025-000010")
   * @param token 
   * @param digitalId 
   * @returns 
  *************************************************************************************/
  public static getTicketByDigitalId = async (token: string, digitalId: string, controller?: AbortController) => {
    const url = `${backendUrl}/by-digital-id/${digitalId}`;
    return axios.get(url, { ...getConfig(token), signal: controller?.signal }).then((res) => {
      return res.data;
    });
  };
  /***********************************************************************************
   * 
   * @param token 
   * @param params 
   * @param controller 
   * @returns 
  *************************************************************************************/
  public static createTicket = async (token: string, params:Partial<TicketInfo> ) => {
    const url = `${backendUrl}`;
    return axios.post(url, params,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };
  /*************************************************************************************
   * 
   * @param token 
   * @param params 
   * @param controller 
   * @returns 
  **************************************************************************************/
  public static updateTicket = async (token: string, params:Partial<TicketInfo> ) => {
    const url = `${backendUrl}/${params.id}`;
    return axios.put(url, params,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };
  public static isTicketExist = async (token: string, ticketNumber:string ) => {
    const url  = `${backendUrl}/exists?ticketNumber=${ticketNumber}`;
    return axios.get(url, getConfig(token)).then((res) => {
      return res.data;
    });
  };

  public static signOffTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/sign-off`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };
  public static submitTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/submit`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };
  public static returnTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/return`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };
  public static verifyTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/verify`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  public static UnsignOffTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/unsign-off`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  /***********************************************************************************
   * Get notes for a ticket
   * @param token 
   * @param ticketId 
   * @returns 
  *************************************************************************************/
  public static getTicketNotes = async (token: string, ticketId: string) => {
    const url = `${backendUrl}/${ticketId}/notes`;
    return axios.get(url, getConfig(token)).then((res) => {
      return res.data;
    });
  };

  /***********************************************************************************
   * Add a note to a ticket
   * @param token 
   * @param ticketId 
   * @param body - note message
   * @param visibility - optional 'External' (shared with operator & vendor) or 'Internal'; when omitted the API decides from the user's role
   * @returns 
  *************************************************************************************/
  public static addTicketNote = async (token: string, ticketId: string, body: string, visibility?: 'Internal' | 'External') => {
    const url = `${backendUrl}/${ticketId}/notes`;
    const payload = visibility ? { body, visibility } : { body };
    return axios.post(url, payload, { ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  public static approveTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/approve`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  public static UnapproveTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}/unapprove`;
    return axios.post(url, data,{ ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  public static deleteTicket = async (token: string, ticketNumber:string, data: any) => {
    const url = `${backendUrl}/${ticketNumber}`;
    return axios.delete(url, { ...getConfig(token), data }).then((res) => {
      return res.data;
    });
  }

  /***********************************************************************************
   * Flag a ticket
   * @param token 
   * @param ticketNumber 
   * @returns 
  *************************************************************************************/
  public static flagTicket = async (token: string, ticketNumber: string) => {
    const url = `${backendUrl}/${ticketNumber}/set-flag`;
    return axios.post(url, {}, { ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  /***********************************************************************************
   * Unflag a ticket
   * @param token 
   * @param ticketNumber 
   * @returns 
  *************************************************************************************/
  public static unflagTicket = async (token: string, ticketNumber: string) => {
    const url = `${backendUrl}/${ticketNumber}/remove-flag`;
    return axios.post(url, {}, { ...getConfig(token) }).then((res) => {
      return res.data;
    });
  };

  /*************************************************************************************
   *
   * // 1- Ticket Status. from Domain 
    // const req1 = axios.get(`${lookupUrl}/lookup-type/${domianTableLookupIdTickStatus}?featureId=${domianTableStatusFeature}&atDate=${formattedDate}&allLookupFields=true`, { ...getConfig(token,domianTableSubKey)});
    // // 3 - forest Area from domain table
    // const req3 = axios.get(`${lookupUrl}/lookup/type?lookupTypeIds=${domianTableLookupIdForestrArea}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});
    // // 4 - resource type
    // const req4 = axios.get(`${lookupUrl}/lookup/type?lookupTypeIds=${domianTableLookupIdResourceType}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});
    // // 6 - From domian table: cost center
    // const req6 = axios.get(`${lookupUrl}/lookup/type?lookupTypeIds=${domianTableLookupIdCostCenter}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});
    // get all what we need from Lookup in one call
    
    // const lookupEquType = `${lookupUrl}/lookup/type?lookupTypeIds=${domianTableLookupIdEquimentType}&lookupTypeIds=${domianTableLookupIdTickStatus}&currentDate=2025-12-12`;
    // return axios.get(lookupEquType, { ...getConfig(token,true)}).then((res:any) =>{
    //   console.log(res);
    // }); 
  **************************************************************************************/
  public static loadPrerequisite = (token: string) => {
    
    const today = new Date(); const formattedDate = today.toISOString().split('T')[0];
    const qparams='';
    const equipmentTypesReq = axios.get(`${firesUrl}/equipment`, { ...getConfig(token,firesSubKey)});

    // From our databae: get Contractor names from our database
    const contractorReq = axios.get(`${backendUrl}/contractor-names/?search=${qparams}`, { ...getConfig(token)});
    
    // From Lookups - forest Area from domain table
    //const forestAreaReq = axios.get(`${lookupUrl}/lookup/type?lookupTypeIds=${domianTableLookupIdForestrArea}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});
    
    // From Lookups - all what we need for Cost Summary
    const costSummaryInfoReq = axios.get(`${lookupUrl}/feature/lookups?featureIds=${domianTableFeature}&atDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});
    
    // relationShip between Rate RType and Activity Code
    const lookupRelationsReq = axios.get(`${lookupUrl}/lookup-relationship?lookupRelationshipId=${domianTableRelationshipRateTypeCostingActivityId}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});
    
    const forestAreaCostCenterRelationUrl = axios.get(`${lookupUrl}/lookup-relationship?lookupRelationshipId=${domianTableRelationshipForestAreaCostCenterId}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});

    const equipmentSpecRatePerUnitRelationUrl = axios.get(`${lookupUrl}/lookup-relationship?lookupRelationshipId=${domianTableRelationshipEquipmentSpecRatePerUnitId}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});

    // "Work performed" activity list (used by the Work performed section)
    const workPerformedListReq = axios.get(`${lookupUrl}/lookup-relationships/key?lookupRelationshipKeys=${domianTableRelationshipKeyWorkPerformed}&currentDate=${formattedDate}`, { ...getConfig(token,domianTableSubKey)});

    
    // intenral Order
    //const qSearch='';
    //const internalOrderReq = axios.get(`${financeUrl}/GetInternalCode?listType=AviationCustomList&search=${qSearch}`,  { ...getConfig(token,financeSubKey)});
   
    return axios.all([
      equipmentTypesReq,
      contractorReq,
      forestAreaCostCenterRelationUrl,
      costSummaryInfoReq,
      lookupRelationsReq,
      equipmentSpecRatePerUnitRelationUrl,
      workPerformedListReq,
      /*,internalOrderReq*/]).then((res:any) => {
      const ret = {
        
        equipmentTypeList:res[0].data.map((x:any) => ({label:x.description,value:x.id.toString()}))?.sort((a:GenListType,b:GenListType) => a.label.localeCompare(b.label)),
        contractorsList:  res[1].data.map((x:any) => ({label:x,value:x}))?.sort((a:GenListType,b:GenListType) => a.label.localeCompare(b.label)),
        
        

        // costSummary related Info
        costRateUnitList:   res[3].data[0].LookupTypes.find((e:any) => wdpUtil.strEqual(e.LookupTypeId, domianTableLookupIdUnitType))?.Lookups?.map((x:any)         => ({label:x.Description?.toLowerCase(),value:x.Description?.toLowerCase()})),
        ticketStatusList:   res[3].data[0].LookupTypes.find((e:any) => wdpUtil.strEqual(e.LookupTypeId, domianTableLookupIdTickStatus))?.Lookups?.map((x:any)       => ({label:x.Description,value:x.LookupId?.toString()})),
        resourceTypeList:   res[3].data[0].LookupTypes.find((e:any) => wdpUtil.strEqual(e.LookupTypeId, domianTableLookupIdResourceType))?.Lookups?.map((x:any)     => ({label:x.Description,value:x.LookupId?.toString()})),
        
        costRateTypeList:   res[3].data[0].LookupTypes.find((e:any) => wdpUtil.strEqual(e.LookupTypeId, domianTableLookupIdCostRateType))?.Lookups,
        genericRelationsList:[...res[4].data,...res[2].data,...res[5].data],
        // Raw WORK_PERFORMED lookup-relationships/key response, kept as-is (unflattened) - it bundles
        // several lookupTypeIds per item (39=Worked Performed, 57=Assigned To Wildfire, 58=Fuel Provided
        // by GoA, 19=Rate Type, 18=Costing Activity). Callers extract whichever lookupTypeId(s) they need.
        workPerformedRelationsList: res[6]?.data ?? [],
        //internalOrderList  :wdpUtil.sortOptList('internalOrder',res[5].data?.data)
      };
      

      return ret;
    });
  }

  /***********************************************************************************
   * 
   * @param token 
   * @param params 
  *************************************************************************************/
  // public static queryContractors = (token: string,qparams:string): => {
  // const url  = `${backendUrl}/contractor-names?search=${qparams}`;
  //   return axios.get(url, { ...getConfig(token,firesSubKey1) }).then((res) => {
  //     return res.data;
  //   }).catch(error => console.log(error));

  // }
  /***********************************************************************************
   * 
   * @param token 
   * @param params 
   * @returns 
  *************************************************************************************/
  public static queryFires = (token: string,qSearch:string,controller:AbortController) => {
    const today = new Date(); //const formattedDate = today.toISOString().split('T')[0];
    const year = today.getFullYear().toString();
    const url  = `${aviationApiUrl}/fire-number/get`;
    
    const _queryParams={
      "search": qSearch,
      "year":year,
      "paginationInfo": {
        "perPage": 1500,
        "page": 1
      }
    }
    
    return axios.post(url, _queryParams,{...getConfig(token),signal: controller?.signal}).then((res) => {
      return res.data;
    });
  };
  
  /***********************************************************************************
   * 
   * @param token 
   * @param params 
   * @returns 
  *************************************************************************************/
  public static queryContracts = (token: string,qSearch:string,formattedDate:string) => {
    const url = `${firesUrl}/contract?search=${qSearch}&timeTicketDate=${formattedDate}`; 
    return axios.get(url, { ...getConfig(token,firesSubKey)}).then(res =>{
      return res.data;
    })
  };
  public static queryCostCenter = (token: string,qSearch:string,controller:AbortController|null) => {
    const url = `${financeUrl}/GetCostCenter?listType=AviationCustomList&Search=${qSearch}`; 
    return axios.get(url, { ...getConfig(token,financeSubKey),signal: controller?.signal}).then(res =>{
      return res.data.data;
    })
  };
  
  /***********************************************************************************
   * 
   * @param token 
   * @param params 
   * @returns 
   *  From Fires: get equipment types and Contracts
    // 0 - equipment types from FIRES..// temp  we will get equiomnt type from Fires..later will get them from domain
  *************************************************************************************/
  // public static queryEquipments = (token: string,formattedDate:string) => {
  //   const url = `${firesUrl}/equipment`; 
  //   return axios.get(url, { ...getConfig(token,firesSubKey)}).then(res =>{
  //     return  res.data;
  //   })
  // };
  /***********************************************************************************
   * 
   * @param token 
   * @param params 
   * @returns 
   * // From Finance: InternalCode..caller must have this Role Fin_Invoice_V
  *************************************************************************************/
  public static queryInternalCodes = (token: string,qSearch:string,controller?: AbortController) => {
    const url = `${financeUrl}/GetInternalCode?listType=AviationCustomList&search=${qSearch}`;
    return axios.get(url, { ...getConfig(token,financeSubKey),signal: controller?.signal}).then(res =>{
      return   res.data.data;
    })
  };
  
  public static async queryInternalCodesAsync(token: string, qSearch: string, controller?: AbortController) {
    const url = `${financeUrl}/GetInternalCode?listType=AviationCustomList&search=${qSearch}`;
    const res = await axios.get(url, {
      ...getConfig(token, financeSubKey),
      signal: controller?.signal
    });
    return res.data.data;
  }
  /***********************************************************************************
   * 
   * @param token 
   * @param params 
   * @returns 
  *************************************************************************************/    
  public static queryTicketDep = (token: string,ticketDep: {id:string,contratNo:string,formattedDate:string},controller?: AbortController) => {
    
    const depUrl1 = `${firesUrl}/contract?search=${ticketDep.contratNo}&timeTicketDate=${ticketDep.formattedDate}`; 
    const depReq1 =  axios.get(depUrl1, { ...getConfig(token,firesSubKey), signal: controller?.signal});
    
    const depUrl2 = `${firesUrl}/contract/${ticketDep.contratNo}/equipment?timeTicketDate=${ticketDep.formattedDate}`; 
    const depReq2 =  axios.get(depUrl2, { ...getConfig(token,firesSubKey), signal: controller?.signal});

    return axios.all([depReq1,depReq2]).then((res:any) => {
      return   {contactInfo:res[0].data,rawJson:res[1].data};
    })
  };

  
  /**
   * 
   * @param token 
   * @param contrctNo 
   * @param qSearch 
   * @returns 
   * NOTE; if contract has no equipment then the result will be empty array..
   * foe testing usue this contract 22LFD019, 26LFD057
   */
  public static loadResourceSnapshotRawJson = (token: string,contrctNo:string,timeTicketDate:string) => {
    //https://apim.wildfireapps-dev.alberta.ca/time-fires/contract/21HFD012/equipment
    const url = `${firesUrl}/contract/${contrctNo}/equipment?timeTicketDate=${timeTicketDate}`; 
    return axios.get(url, { ...getConfig(token,firesSubKey)}).then(res =>{
      return res.data;
    })
    
  };
 
  // call this endpoint to get all domain table values
 // https://apim.wildfireapps-dev.alberta.ca/domain-table-client/feature/lookups?featureIds=10&atDate=2026-01-09
  
  // this is howe to get intrnal code and GetCostCenter
//https://apim.wildfireapps-dev.alberta.ca/wildfire-finance-api-dev/GetInternalCode?listType=AviationCustomList&Search=123
//https://apim.wildfireapps-dev.alberta.ca/wildfire-finance-api-dev/GetCostCenter?listType=AviationCustomList&Search=1
// Role Fin_Invoice_V

}